import React from 'react';

import './LoadingDots.css';

// modified from https://github.com/the-unsullied/react-loading-dots/

const LoadingDots = ({ flavor, ...domProps }) => (
    <div
        {...domProps}
        className={`loading-dots loading-dots--animated ${domProps.className || ''}`}
    >
        <div className={`loading-dots__dot loading-dots__dot--1 bg-${flavor}`} />
        <div className={`loading-dots__dot loading-dots__dot--2 bg-${flavor}`} />
        <div className={`loading-dots__dot loading-dots__dot--3 bg-${flavor}`} />
    </div>
);

LoadingDots.defaultProps = {
    flavor: 'secondary',
};

export default LoadingDots;
